import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { uipApiInstance } from '../../services';

type initialStateType = {
    loading: boolean;
    error: string | null;
    data: {} | null;
};
const initialState: initialStateType = {
    loading: false,
    error: null,
    data: null
};

export const fetchRecentUpdates = createAsyncThunk(
    'recentUpdates/fetchRecentUpdates',
    async ({ tenant }: { tenant: string }, { rejectWithValue }) => {
        let url = '/api/advice/getrecentupdates';
        if (tenant) {
            url += `?tenant=${tenant}`;
        }
        try {
            const response = await uipApiInstance.get(url);
            return response.data?.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Error fetching recent updates');
        }
    }
);

export const updateRecentUpdate = createAsyncThunk(
    'recentUpdates/updateRecentUpdate',
    async (updateData: any, { rejectWithValue }) => {
        try {
            const response = await uipApiInstance({
                method: 'POST',
                url: '/api/advice/insertrecentupdates',
                data: {
                    recentUpdateInfo: updateData
                }
            });
            if (response.status == 200 && response.data?.success) {
                return response.data;
            }
            return rejectWithValue('Error updating recent update');
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Error updating recent update');
        }
    }
);

const recentUpdatesSlice = createSlice({
    name: 'recentUpdates',
    initialState,
    reducers: {
        updateWithStaticData(state, action) {
            state.data = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchRecentUpdates.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchRecentUpdates.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchRecentUpdates.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(updateRecentUpdate.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateRecentUpdate.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.recentUpdateInfo;
            })
            .addCase(updateRecentUpdate.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    }
});

export const { updateWithStaticData } = recentUpdatesSlice.actions;
export default recentUpdatesSlice.reducer;
